var locale = {
  placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/time-picker/locale/en_US.js
// module id = 160
// module chunks = 0